const cardBrand = {
	mastercard: 'mastercard',
	hipercard: 'hipercard',
	visa: 'visa',
	amex: 'amex',
	elo: 'elo'
}

export default cardBrand
